/**
 * Parses a markdown table string into structured data
 * @param markdown - The markdown table string
 * @returns Array of objects representing table rows
 */
export function parseMarkdownTable(markdown: string): Record<string, string>[] {
    if (!markdown) return [];

    const lines = markdown.trim().split("\n");
    if (lines.length < 3) return [];

    const headerLine = lines[0];
    const headers = headerLine
        .split("|")
        .map((h) => h.trim())
        .filter((h) => h !== "");

    const keys = headers.map((header) =>
        header
            .toLowerCase()
            .replace(/[^\w\s]/g, "")
            .replace(/\s+(.)/g, (_, char) => char.toUpperCase())
            .replace(/\s/g, ""),
    );

    const dataRows = lines.slice(2);

    return dataRows
        .map((line) => {
            const values = line
                .split("|")
                .map((v) => v.trim())
                .filter((v) => v !== "");

            if (values.length !== keys.length) return null;

            const row: Record<string, string> = {};
            keys.forEach((key, index) => {
                row[key] = values[index];
            });

            return row;
        })
        .filter((row): row is Record<string, string> => row !== null);
}
